// Generated by genversion.
export const version = '2.2.3';
//# sourceMappingURL=version.js.map